import React, { useState } from 'react'
import Post from '../../../components/Post/Post'
import styles from './main.module.css'
import { Line,Pie,Bar } from 'react-chartjs-2';

const viewdata = {
  labels: ['1/2','2/2','3/2','4/2','5/2','6/2','7/2','8/2', '9/2', '10/2', '11/2', '12/2', 'today'],
  datasets: [
    {
      label: 'Number of Views',
      data: [100, 119, 140, 250, 300, 350,300,350,400,500,550,300,400],
      fill: false,
      backgroundColor: 'rgb(133, 36, 189)',
      borderColor: 'rgba(133, 36, 189, 0.2)',
    }
  ],
}

const commentdata = {
  labels: ['1/2','2/2','3/2','4/2','5/2','6/2','7/2','8/2', '9/2', '10/2', '11/2', '12/2', 'today'],
  datasets: [
   {
    label: 'Number of Likes',
    data: [2, 50, 100, 120, 130, 140,160,165,170,175,180,195,250],
    fill: false,
    backgroundColor: 'rgb(255, 0, 0)',
    borderColor: 'rgba(255, 0, 0, 0.2)',
    }
    
  ],
}

const likedata = {
    labels: ['1/2','2/2','3/2','4/2','5/2','6/2','7/2','8/2', '9/2', '10/2', '11/2', '12/2', 'today'],
    datasets: [
   {
        label: 'Number of Comments',
        data: [5, 5, 6, 7, 8, 12,13,16,28,28,40,49,50],
        fill: false,
        backgroundColor: 'rgb(78, 154,0)',
        borderColor: 'rgba(78,154,0, 0.2)',
        }
    ],
  }
  const options = {
      
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
  }


const PostPrev =()=>{
    return(
        <div className={styles.postPrev}>
            <img src="https://www.gettyimages.com/gi-resources/images/500px/983794168.jpg"></img>
        </div>
    )
}



const CurrentPost =()=>{
    const [postSelected,setPostSelected]=useState(false)

    const borderbottom ={borderBottom:"solid 2px #7124BD"};

    return(
        <div className={styles.currentPostCon}>
          <div className={styles.ToggleCon}>
          <div className={styles.Toggle}>
            <div onClick={()=>setPostSelected(false)} style={postSelected?{}:borderbottom}>
            Latest Post
            </div>
            <div onClick={()=>setPostSelected(true)} style={postSelected?borderbottom:{}}>
            All Posts
            </div>
            </div>
          </div>
            <br/>
            {postSelected?
            <div>
            <div className={styles.PostPrevCon}>
           
            <div className={styles.postPrev}>
            <img src="https://www.gettyimages.com/gi-resources/images/500px/983794168.jpg"></img>
        </div>

        <div className={styles.postPrev}>
            <img src="https://resize.indiatvnews.com/en/resize/newbucket/715_-/2018/02/propose-1517999844.jpg"></img>
        </div>
        <div className={styles.postPrev}>
            <img src="http://www.freedigitalphotos.net/images/img/homepage/394230.jpg"></img>
        </div>
        <div className={styles.postPrev}>
            <img src="https://www.filmibeat.com/ph-big/2019/07/ismart-shankar_156195627930.jpg"></img>
        </div>
        <div className={styles.postPrev}>
            <img src="https://static.toiimg.com/thumb/msid-24245804,width-748,height-499,resizemode=4,imgsize-113353/.jpg"></img>
        </div>

        <div className={styles.postPrev}>
            <img src="https://www.shaadidukaan.com/vogue/wp-content/uploads/2019/08/hug-kiss-images.jpg"></img>
        </div>

        <div className={styles.postPrev}>
            <img src="https://img.freepik.com/free-vector/vector-images-forest-daytime_46176-155.jpg?size=626&ext=jpg"></img>
        </div>


        <div className={styles.postPrev}>
            <img src="https://static.remove.bg/remove-bg-web/3b88866d32d310b59bcf27d93297634aa540fbed/assets/start-0e837dcc57769db2306d8d659f53555feb500b3c5d456879b9c843d1872e7baa.jpg"></img>
        </div>

        <div className={styles.postPrev}>
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnltfxyRHuEEUE4gIZp9fr77Q8goigP7mQ6Q&usqp=CAU"></img>
        </div>
        <div className={styles.postPrev}>
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSy1uZTBlxjOfVEiZsIt9FSo_bkxgEb6_OslQ&usqp=CAU"></img>
        </div>
        <div className={styles.postPrev}>
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDkvFCLSMbUU6Bqb1m-0y3LPAQ7_Gcs-PNZw&usqp=CAU"></img>
        </div>
        <div className={styles.postPrev}>
            <img src="https://www.inpixio.com/remove-background/images/animation-light-square.gif"></img>
        </div>


            </div>
            <div style={{textAlign:"center",fontSize:"larger",marginTop:"20px"}}>Please select a post to view stat</div>
            </div>:
            <div>
        <div className={styles.currentPost}>
            <Post/>
            

        </div>
        <div style={{display:"flex",alignItems:"center",flexDirection:'column'}}>
          <div className={styles.PostLine}>
                              
                <Line  data={viewdata} options={options} />
                </div>
                <br/>  
                <div className={styles.PostLine}>
                <Line  data={likedata} options={options} />
               </div>
               <br/>
               <div className={styles.PostLine}>
                <Line style={{marginTop:"10px"}} data={commentdata} options={options} />
                </div>
                </div>
                </div>}
        <div style={{height:"20px"}}></div>
        </div>
    )
    }

export default CurrentPost